import { render, staticRenderFns } from "./UpdateHotPluggable.vue?vue&type=template&id=5687f764&"
import script from "./UpdateHotPluggable.vue?vue&type=script&lang=js&"
export * from "./UpdateHotPluggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports